import React from 'react';
import {QuerySampleItem} from '../content/types';
import QueryCopyButton from './QueryCopyButton';

interface Props {
    item: QuerySampleItem;
    compact?: boolean;
}

const QuerySampleCard = React.memo<Props>(({item, compact = false}) => (
    <article className={`query-help-modal__sample-card${compact ? ' query-help-modal__sample-card--compact' : ''}${item.variant === 'anti' ? ' query-help-modal__sample-card--anti' : ''}`}>
        <div className="query-help-modal__sample-card-header">
            <h4 className="query-help-modal__sample-card-title">{item.title}</h4>
            {item.query ? <QueryCopyButton query={item.query} /> : null}
        </div>

        {item.query ? (
            <pre className="query-help-modal__query-block">{item.query}</pre>
        ) : null}

        {item.description ? (
            <p className="query-help-modal__sample-description">{item.description}</p>
        ) : null}

        {item.matches?.length ? (
            <div className="query-help-modal__matches">
                <span className="query-help-modal__matches-label">Matches examples:</span>
                <ul className="query-help-modal__matches-list">
                    {item.matches.map((match) => (
                        <li key={match}>{match}</li>
                    ))}
                </ul>
            </div>
        ) : null}
    </article>
));

export default QuerySampleCard;
